﻿export const AppContainerId = 'veilederUtstyrsstipend';
export const BoksA = 'boks-a';
export const BoksBa = 'boks-ba';
export const BoksBb = 'boks-bb';
export const BoksCa = 'boks-ca';
export const BoksCb = 'boks-cb';
export const BoksCc = 'boks-cc';
export const BoksCd = 'boks-cd';
export const BoksCe = 'boks-ce';
export const BoksDa = 'boks-da';
export const BoksDb = 'boks-db';
export const BoksDc = 'boks-dc';
export const BoksDd = 'boks-dd';
export const BoksDdVg3 = 'boks-ddvg3';
export const BoksDe = 'boks-de';

export const BoksEa = 'boks-ea';
export const BoksEb = 'boks-eb';
export const BoksEc = 'boks-ec';
export const BoksEd = 'boks-ed';
